module.exports = __webpack_public_path__ + "static/media/emilien.31cb4ddf.jpg";